(function () {
    angular.module('PWAPoCApp').constant('appVersion', '24.06.11');
})();
